import React from 'react';
import CandidatesOverviewNavigationSidebar from '@/Components/CandidatesOverview/CandidatesOverviewNavigationSidebar';
import useCompanyId from '@/Hooks/UseCompanyId';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';

const CandidatesOverviewPageNavigationSidebar = () => {
    const { assessmentId, clientId, tabValue, handleTabChange } = useCandidatesOverviewContext();
    const companyId = useCompanyId();

    return (
        <CandidatesOverviewNavigationSidebar
            assessmentId={assessmentId}
            clientId={clientId || ''}
            companyId={companyId}
            isAgenticSearchSelected={false}
            isIdentifiedAiSearchSelected={false}
            isShortlistedAiSearchSelected={false}
            selectedApplicantOverviewTab={tabValue}
            handleApplicantOverviewTabChange={handleTabChange}
        />
    );
};

export default CandidatesOverviewPageNavigationSidebar;
